/** @format */

import { useDispatch, useSelector } from "react-redux";
import "../App.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { fillParamURL, recargarComponente } from "../redux/slices/userSlice";
import { useState } from "react";

const Solidarios = () => {
  const dispatch = useDispatch();
  const path = useSelector((state) => state.sitePath);
  const idGrupo = useSelector((state) => state.paramURL);
  const user = useSelector((state) => state.user)?.id;
  const email = useSelector((state) => state.user)?.email;

  const [emailSent, setEmailSent] = useState(false);

  console.log(idGrupo);

  useEffect(() => {
    if (idGrupo && !emailSent) {
      const obj = {
        // to: "daniela.f.renteria@gmail.com",
        to: email,
        from: "contactofunam@funam.mx",
        id_grupo: idGrupo,
        id_alumno: user,
      };
      axios
        .post(path + "/email.php", obj)
        .then((res) => {
          dispatch(fillParamURL(false));
          setEmailSent(true);
          if (res.data === "Error") {
            console.log(res.data);
          } else {
            // console.log(res.data);
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    }
  }, [idGrupo, emailSent]);

  let links = [
    {
      link: "//www.fundacionunam.org.mx/new/por-que-apoyar-a-funam/",
      titulo: "Por qué sumarte a FUNAM",
    },
    {
      link: "//www.fundacionunam.org.mx/new/beneficios-de-apoyar/",
      titulo: "Beneficios de donar",
    },
    {
      link: "//www.fundacionunam.org.mx/new/beneficios-dentro-de-la-unam/",
      titulo: "Beneficios dentro de la UNAM",
    },
    {
      link: "//www.fundacionunam.org.mx/new/formas-de-aportar/",
      titulo: "Formas de donar",
    },
    {
      link: "//www.fundacionunam.org.mx/new/asociate/",
      titulo: "Súmate",
    },
    {
      link: "//www.fundacionunam.org.mx/new/ser-asociado/",
      titulo: "Ser aliado",
    },
    {
      link: "//www.fundacionunam.org.mx/new/ser-donante/",
      titulo: "Ser donante",
    },
    {
      link: "//www.fundacionunam.org.mx/new/formas-de-aportar/",
      titulo: "Formas de donar",
    },
    {
      link: "//www.fundacionunam.org.mx/new/visitas-guiadas/",
      titulo: "Visitas guiadas",
    },
    {
      link: "//fundacionunam.org.mx/sumate",
      titulo: "Súmate a Fundación UNAM",
    },
  ];

  return (
    <section className='container'>
      <div className='row'>
        <div className=' col-lg-5'>
          <figure>
            <img
              src='https://www.fundacionunam.org.mx/wp-content/uploads/2021/03/ASÓCIATEDONA.jpg'
              alt='Súmate a Fundación UNAM'
              className='figure-img img-fluid rounded mx-auto d-block'
            />
          </figure>
        </div>
        <div className='col-lg-7 my-5 px-5'>
          <div className='info-becarios'>
            <h2>¿Por qué donar a Fundación UNAM?</h2>
            <div className='bullets'>
              <p>
                Porque trabaja a favor de las causas de la Universidad Nacional
                Autónoma de México y funge como lazo de unión, absolutamente
                incluyente, de quienes integran la comunidad universitaria:
                alumnos, académicos, trabajadores, funcionarios de la
                administración y ex alumnos.
              </p>
              <br></br>
              <p>
                Porque promueve fuertemente la afiliación de quienes se
                identifican con la Universidad y sirve de vehículo para
                materializar, en acciones concretas y a través de donativos, ese
                sentimiento de simpatía o gratitud.
              </p>
            </div>

            <div>
              <ul>
                {links.map((link, i) => (
                  <li key={i}>
                    <Link to={link.link}>{link.titulo}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className='w-100 d-flex justify-content-center'>
              <Link
                to={{ pathname: "//fundacionunam.org.mx/sumate" }}
                target='_blank'
                className='btn btn-primary'
              >
                Súmate a Fundación UNAM
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solidarios;
